import { LevelEditorSidePanel } from './LevelEditorSidePanel';
import { LevelEditorDropZoneManager } from './LevelEditorDropZones';
import { LevelEditorCandyHelper } from './LevelEditorCandyHelper';
import { LevelEditorStateTracker } from './LevelEditorStateTracker';
import { EditorStorageManager } from '../MapEditor/EditorStorageManager';
import LvlObject from '../../Elements/GameState/Managers/LvlObject';

// eslint-disable-next-line max-len
export const DEFAULT_LEVEL_DATA = '{"moves":15,"nrOfTypes":5,"rainbowChance":0,"bgImg":"bg_1.jpg","goal":["collect",[["1",10]]],"starsReq":[250,500,750],"drops":{"chest":0,"chain":0,"infection":0,"goalCandy":0},"levelData":[[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]],[["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"],["r"]]],"difficulty":4.79,"group":0,"collectList":["4"],"goalDrops":[],"predefinedDrops":[[],[],[],[],[],[],[],[],[]],"id":"1","collectCells":null,"noBoosters":true,"disableBubble":true,"completeAction":2}';

const INPUT_KEYS = {
  one: Phaser.Keyboard.ONE,
  two: Phaser.Keyboard.TWO,
  three: Phaser.Keyboard.THREE,
  four: Phaser.Keyboard.FOUR,
  five: Phaser.Keyboard.FIVE,
  six: Phaser.Keyboard.SIX,
  seven: Phaser.Keyboard.SEVEN,
  eight: Phaser.Keyboard.EIGHT,
  nine: Phaser.Keyboard.NINE,
  zero: Phaser.Keyboard.ZERO,
  tilde: Phaser.Keyboard.B,

  Z: Phaser.Keyboard.Z,
  X: Phaser.Keyboard.X,
  C: Phaser.Keyboard.C,
  V: Phaser.Keyboard.V,
  B: Phaser.Keyboard.B,
  N: Phaser.Keyboard.N,
  M: Phaser.Keyboard.M,
  L: Phaser.Keyboard.L,

  Q: Phaser.Keyboard.Q,
  W: Phaser.Keyboard.W,
  E: Phaser.Keyboard.E,
  R: Phaser.Keyboard.R,
  T: Phaser.Keyboard.T,
  Y: Phaser.Keyboard.Y,
  U: Phaser.Keyboard.U,

  O: Phaser.Keyboard.O,
  P: Phaser.Keyboard.P,

  A: Phaser.Keyboard.A,
  S: Phaser.Keyboard.S,
  D: Phaser.Keyboard.D,
  F: Phaser.Keyboard.F,
  G: Phaser.Keyboard.G,
  SPACE: Phaser.Keyboard.SPACEBAR,
  ENTER: Phaser.Keyboard.ENTER,
};

/**
 * Class for Level Editor State
 */
export class LevelEditor {
  /**
   * initialize the  level editor
   * @param {string} lvlId id of level to open for editing
   */
  init(lvlId) {
    this._storageManager = EditorStorageManager.getInstance();

    this._lvlId = lvlId;
    this._lvlIndex = G.Helpers.levelDataMgr.getIndexOfLevelId(this._lvlId);
    this._lvlData = G.Utils.clone(G.Helpers.levelDataMgr.getRawLevelById(this._lvlId));

    this.EDITOR = true;
    this.NOTRESIZABLE = true;

    // game still uses these messy globals for level refernces.
    G.lvl = new LvlObject(this._lvlIndex, this._lvlData);
    // init the state tracker for undo / redo functionality
    this._initEditorStateTracker();
  }

  /**
   * create level editor scene
   */
  create() {
    // set bounds and viewport size for editor
    game.world.setBounds(0, 0, game.width, game.height);
    game.scale.setGameSize(2000, 1500);
    // create editor components
    this._createLevelTitle();
    this._createEditorGameBoard();
    this._createEditorDropZones();
    this._createEditorSidePanel();
    // configure input events
    this._configureKeys();
    this._configureMouseInput();
  }

  /**
   * create level title field
   */
  _createLevelTitle() {
    this._txt = game.add.existing(new G.Text(0, 0, `LEVEL ${this._lvlIndex + 1}(${this._lvlId})`, {
      style: 'font-white',
      fontSize: '50px',
    }, 0, 400));
  }

  /**
   * create the game board to be used by the editor
   */
  _createEditorGameBoard() {
    this._board = new G.Board(this._lvlData, 72, true);
    this._board.update = () => {};
    this._board.actionManager.glowPossibleMoves = () => {};
    this._board.position.setTo(50, 150);
    this._board.boardIce.alpha = 0.7;
    this._board.inputController.destroy();
  }

  /**
   * create editor drop zones
   */
  _createEditorDropZones() {
    this._dropZones = new LevelEditorDropZoneManager(this._board, this._lvlData.predefinedDrops);
    this._dropZones.signals.onDropModified.add(() => {
      this._captureEditorState();
    });
  }

  /**
   * create editor side panel
   */
  _createEditorSidePanel() {
    this._sidePanel = new LevelEditorSidePanel(900, this._lvlData);
    this._sidePanel.signals.undo.add(() => {
      this._undoLastChange();
    });
    this._sidePanel.signals.redo.add(() => {
      this._redoChange();
    });
    this._sidePanel.signals.reset.add(() => {
      this._resetChanges();
    });
    this._sidePanel.signals.onFieldChanged.add(() => {
      this._captureEditorState();
    });
    this._sidePanel.updateUndoAndRedoState(
      this._stateTracker.undosAvailable,
      this._stateTracker.redosAvailable,
      this._stateTracker.getUndoStatusString(),
    );
  }

  /**
   * init the state trackier for undo / redo functionality
   */
  _initEditorStateTracker() {
    this._stateTracker = new LevelEditorStateTracker(this._lvlData);
  }

  /**
   * capture the current state of the editor
   */
  _captureEditorState() {
    const stateObj = this._sidePanel._exportLevel();
    this._stateTracker.addState(stateObj);
    this._sidePanel.updateUndoAndRedoState(
      this._stateTracker.undosAvailable,
      this._stateTracker.redosAvailable,
      this._stateTracker.getUndoStatusString(),
    );
    this._storageManager.saveLevelChanges(this._lvlId, stateObj);
    this._sidePanel.updateSavedStatus();
  }

  /**
   * undo last change
   */
  _undoLastChange() {
    const stateObj = this._stateTracker.getUndoState();
    this._restoreState(stateObj);
  }

  /**
   * redo a change
   */
  _redoChange() {
    if (!this._stateTracker.redosAvailable) return;
    const stateObj = this._stateTracker.getRedoState();
    this._restoreState(stateObj);
  }

  /**
   * reset all changes to level
   */
  _resetChanges() {
    this._lvlData = this._storageManager.resetLevelChanges(this._lvlId);
    this._initEditorStateTracker();
    this._restoreState(this._lvlData);
    this._levelWasModified = false;
    this._sidePanel.updateSavedStatus();
  }

  /**
   * restore a editor state
   * @param {Object} stateObj
   */
  _restoreState(stateObj) {
    this._sidePanel.signals.undo.removeAll();
    game.input.keyboard.reset();
    // store the board scrolled y
    const boardY = this._board.y;
    // hackity hacks remove and destroy all sprites from the stage as no containers were used for the board
    this._destroyAllSprites();
    // apply the previous level data state and recreate the board and dropzones
    this._lvlData = stateObj;
    G.lvl = new LvlObject(this._lvlIndex, this._lvlData);
    this._createLevelTitle();
    this._createEditorGameBoard();
    this._board.y = boardY;
    this._createEditorDropZones();
    this._createEditorSidePanel();
    this._configureKeys();
    this._storageManager.saveLevelChanges(this._lvlId, stateObj);
    this._sidePanel.updateSavedStatus();
  }

  /**
   * destroy all sprites currently on screen
   */
  _destroyAllSprites() {
    const { world } = game;
    const children = world.children.slice();
    children.forEach((child) => {
      world.removeChild(child);
      child.destroy();
    });
  }

  /**
   * get the candy
   * @returns {Object}
   */
  _getCandyAtPointer() {
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    if (!pos) return false;
    const cellX = pos[0];
    const cellY = pos[1];
    return this._board.getCandy(cellX, cellY);
  }

  /**
   * configure mouse input events
   */
  _configureMouseInput() {
    G.sb('mouseWheelEvent').add((event) => {
      this._board.y += (event.deltaY / 250) * -50;
    });
  }

  /**
   * configure keyboard input keys
   */
  _configureKeys() {
    // define input key list
    this._keys = game.input.keyboard.addKeys(INPUT_KEYS);
    // take a screenshot
    this._keys.ENTER.onDown.add(() => { this._makeScreenshot(); });
    // fill all random candies on board
    this._keys.SPACE.onDown.add(() => {
      this._board.boardCandies.replaceRandomCandies();
      this._captureEditorState();
    });
    // clear all board candies
    this._keys.zero.onDown.add(() => { this._clearAllBoardCandies(); });
    // clear all status effects on board ice, ropes, etc.
    this._keys.O.onDown.add(() => { this._clearAllBoardStatusEffects(); });
    // toggle a board tile as active / inactive
    this._keys.Y.onDown.add(() => { this._toggleInactiveTile(); });
    // apply board status effects
    this._keys.W.onDown.add(() => { this._changeHpToken(this._board.boardIce); });
    this._keys.U.onDown.add(() => { this._changeHpToken(this._board.boardIce); }); // the same as W ?
    this._keys.E.onDown.add(() => { this._changeHpToken(this._board.boardCage); });
    this._keys.R.onDown.add(() => { this._changeHpToken(this._board.boardDirt); });
    this._keys.F.onDown.add(() => { this._changeHpToken(this._board.boardDirtS); });
    this._keys.G.onDown.add(() => { this._changeHpToken(this._board.boardJam); });
    // clear a single tile content
    this._keys.T.onDown.add(() => { this._clearTileContents(); });
    // set collect goal arrow
    this._keys.C.onDown.add(() => { this._toggleCollectGoalArrow(); });
    // loop through specials / bomb for a tile
    this._keys.B.onDown.add(() => { this._loopThroughSpecialCandies(); });

    // apply basic candy type to a tile
    const { candyDataMgr } = G.Helpers;
    candyDataMgr.getAllBaseTypes()
      .filter((type) => type.editorKey)
      .forEach((type) => {
        const key = game.input.keyboard.addKey(Phaser.Keyboard[type.editorKey]);
        key.onDown.add(() => {
          this._setTileCandyBasicType(type);
        });
      });

    // loop through states of a complex status type
    candyDataMgr.getAllStatuses()
      .filter((status) => status.editorKey)
      .forEach((status) => {
        const key = game.input.keyboard.addKey(Phaser.Keyboard[status.editorKey]);
        key.onDown.add(() => {
          this._loopThroughStatusStates(status);
        });
      });
  }

  /**
   * clear all candies on the board
   */
  _clearAllBoardCandies() {
    for (let x = 0; x < 10; x++) {
      for (let y = 0; y < 10; y++) {
        if (this._board.isCellOnBoard(x, y)) {
          const candy = this._board.getCandy(x, y);
          if (candy) candy.destroy();
          this._board.boardCandies.newCandy(x, y, 'r');
        }
      }
    }
    this._captureEditorState();
  }

  /**
   * clear all status effects on the board
   */
  _clearAllBoardStatusEffects() {
    this._dropZones.removeAllElements();
    this._board.clearBoard();
    this._captureEditorState();
  }

  /**
   * clear contents of a single tile
   */
  _clearTileContents() {
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    if (pos && this._board.getCandy(pos[0], pos[1])) {
      this._board.removeCandy(pos[0], pos[1]);
    }
  }

  /**
   * set tile basic candy types
   * @param {string} type
   */
  _setTileCandyBasicType(type) {
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    if (!pos || !this._board.isCellOnBoard(pos[0], pos[1])) return;
    const candy = this._getCandyAtPointer();
    if (candy && candy.baseType.getEditorSymbol() === type.editorSymbol
      && candy.baseType.changeForEditor) {
      candy.baseType.changeForEditor();
    } else {
      if (candy) candy.destroy();
      const newCandy = this._board.boardCandies.newCandy(pos[0], pos[1]);
      newCandy.setBaseType(type);
    }
    this._captureEditorState();
  }

  /**
   * loop through states of complex status types
   * @param {string} type
   */
  _loopThroughStatusStates(status) {
    const element = this._getCandyAtPointer();
    if (!element) return;
    if (element.hasStatus()) {
      if (element.candyStatus.changeForEditor) {
        element.candyStatus.changeForEditor();
      } else {
        element.removeStatus();
      }
    } else {
      element.setStatus(status);
    }
    this._captureEditorState();
  }

  /**
   * toggle a tile as incactive / active
   */
  _toggleInactiveTile() {
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    if (!pos) return;
    if (this._board.boardData.get(pos[0], pos[1]) === 'X') {
      this._board.boardData.set(pos[0], pos[1], null);
      this._board.boardBackground.redraw();
      return;
    }
    this._board.boardData.set(pos[0], pos[1], 'X');
    this._board.boardBackground.redraw();
    this._board.layers.forEach((layer) => {
      if (layer.grid.get(pos[0], pos[1])) layer.removeToken(pos[0], pos[1]);
    });
    this._captureEditorState();
  }

  /**
   * toggle collection goal arrow for a tile
   */
  _toggleCollectGoalArrow() {
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    if (!pos) return;
    this._board.boardCollectCells.editorChangeCC(pos[0], pos[1]);
    this._captureEditorState();
  }

  /**
   * loop through special / bombds for a tile
   */
  _loopThroughSpecialCandies() {
    const element = this._getCandyAtPointer();
    if (!element) return;
    LevelEditorCandyHelper.getInstance().loopThroughSpecials(element);
    this._captureEditorState();
  }

  /**
   * take a screenshot of the current layout
   */
  _makeScreenshot() {
    const fileName = `Level_${(this._lvlIndex + 1).toString().padStart(3, '0')}___id_${this._lvlId}.png`;
    const canvas = document.createElement('canvas');
    canvas.width = game.canvas.width;
    canvas.height = game.canvas.height;
    const ctx = canvas.getContext('2d');
    ctx.rect(0, 0, game.canvas.width, game.canvas.height);
    ctx.fillStyle = '#7cd010';
    ctx.fill();
    ctx.drawImage(game.canvas, 0, 0);
    // eslint-disable-next-line no-undef
    canvas.toBlob((blob) => { saveAs(blob, fileName); });
  }

  /**
   * change token used to a cell
   * @param {Object} layer
   */
  _changeHpToken(layer) {
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    if (!pos) return;
    const cellX = pos[0];
    const cellY = pos[1];
    if (this._board.isCellOnBoard(cellX, cellY)) {
      const elem = layer.getToken(cellX, cellY);
      if (elem) {
        const { hp } = elem;
        layer.destroyCell(cellX, cellY);
        if (hp < layer.config.maxHp) {
          layer.createToken(cellX, cellY, hp + 1);
        }
      } else {
        layer.createToken(cellX, cellY, 1);
      }
    }
    this._captureEditorState();
  }

  /**
   * change the size of the active board
   * @param {number} desiredWidth
   * @param {number} desiredHeight
   */
  changeBoardSize(desiredWidth, desiredHeight) {
    const width = game.math.clamp(desiredWidth, 4, 10);
    const height = game.math.clamp(desiredHeight, 4, 10);
    const oldBoardData = this._board.boardData;
    this._board.boardData = new G.GridArray(width, height, null);
    // eslint-disable-next-line no-unused-vars
    oldBoardData.loop((elem, x, y, data) => {
      if (this._board.boardData.isInGrid(x, y) && elem === 'X') {
        this._board.boardData.set(x, y, 'X');
      }
    });

    this._board.boardBackground.redraw();
    this._board.layers.forEach((layer) => {
      const oldGrid = layer.grid;
      layer.grid = new G.GridArray(width, height, false);
      oldGrid.loop((elem, x, y) => {
        if (layer.grid.isInGrid(x, y)) layer.grid.set(x, y, elem);
        else if (elem && elem.destroy) elem.destroy();
      });
    });
  }

  /**
   * render function
   */
  render() {
    // I dont think there is any need to log this ??
    /*
    game.debug.text(game.time.fps, 300, 10, '#ff0000');
    const pos = this._board.inputController.pointerToCell(game.input.activePointer);
    game.debug.text(this._board.inputController.isPointerInRange(game.input.activePointer), 10, 10, '#ff0000');
    game.debug.text(pos, 10, 40, '#ff0000');
    game.debug.text(this._board.isCellOnBoard(this._board.inputController.pointerToCell(game.input.activePointer)), 10, 80, '#ff0000');
    if (pos) {
      const candy = this._board.getCandy(pos[0], pos[1]);
      if (candy) game.debug.text(candy.candyType, 10, 150, '#ff0000');
    }
    */
  }

  /**
   * shutdown function
   */
  shutdown() {
    G.IMMEDIATE = false;
  }

  /**
   * get a reference to the board Object
   * @returns {G.Board}
   */
  get board() {
    return this._board;
  }

  /**
   * get referene to the editor drop zones
   * @returns {EditorDropZones}
   */
  get dropZones() {
    return this._dropZones;
  }

  /**
   * get a reference to the editor side panel
   * @returns {EditorSidePanel}
   */
  get sidePanel() {
    return this._sidePanel;
  }

  /**
   * get the level data Object
   * @returns {Object}
   */
  get lvlData() {
    return this._lvlData;
  }

  /**
   * get the level ID
   * @returns {Object}
   */
  get lvlId() {
    return this._lvlId;
  }

  /**
   * get the level index
   * @returns {Number}
   */
  get lvlIndex() {
    return this._lvlIndex;
  }
}
